import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStateAdditionalTaxesTable extends Layout {
    buttonAddAdditionalTaxes: Button;
    sourceStatetaxAdditional: DataSource;
    tableAdditionalTaxes: Table;
}
